import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { usePricing } from '../hooks/usePricing';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  const {
    formattedPrice,
    isLoading
  } = usePricing();
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-126">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 bg-chocolate/95 backdrop-blur-md border-t border-copper/20 shadow-[0_-4px_20px_rgba(0,0,0,0.15)] md:hidden z-40" data-id="element-127">
          <div className="px-4 pt-2.5 pb-3" data-id="element-128">
            <p className="text-center text-white/80 text-xs mb-2" data-id="element-129">
              <span className="font-bold text-copper" data-id="element-130">
                Tu Mascota en Amigurumi
              </span>{' '}
              — Patrones por raza en PDF
            </p>
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="btn-pulse w-full bg-copper text-white py-3 rounded-full font-bold shadow-lg text-sm text-center flex items-center justify-center gap-2" data-id="element-131">
              Quiero mis patrones — {isLoading ? '...' : formattedPrice}
              <ArrowRight size={15} data-id="element-132" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}